import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import TextField from 'apollo-react/components/TextField';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { saveRepositoryConfig } from '../../actions/RepositoryConfigurationActions';
import { checkRepositoryName } from '../../api/documentRepositoryConfiguration';
import { REPOSITORY_NAME_VALIDATION_ERROR_MESSAGES } from '../../constants/RepositoryConfigurationConstants';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { validateRepositoryNameOnSaveAs } from '../../utils/repositoryConfigurationUtils';

const useStyles = makeStyles({
  modal: {
    width: 650,
    '& [class*="MuiDialogContent-root"]': {
      paddingBottom: 5,
    },
  },
});

const SaveAsModal = ({
  isOpen,
  initialRepositoryName = '',
  handleClose,
  setIsLoading,
  redirectToRepository,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const translateString = useTranslation();

  const [repositoryName, setRepositoryName] = useState(initialRepositoryName);
  const [error, setError] = useState({ hasError: false, errorText: '' });

  const handleSaveProgressButton = async () => {
    const errorObj = validateRepositoryNameOnSaveAs(repositoryName);

    if (errorObj.hasError) {
      setError(errorObj);
      return;
    }

    const { repositoryExists } = await checkRepositoryName({
      repositoryName,
    });

    if (repositoryExists) {
      setError({
        hasError: true,
        errorText: REPOSITORY_NAME_VALIDATION_ERROR_MESSAGES.UNIQUE,
      });
    } else {
      await dispatch(
        saveRepositoryConfig({
          saveAsNew: true,
          newRepositoryName: repositoryName,
          setIsLoading,
          redirectToRepository,
        })
      );
      handleClose();
    }
  };

  const handleSavedSearchNameFieldBlur = () => {
    const errorObj = validateRepositoryNameOnSaveAs(repositoryName);
    setError(errorObj);
  };

  return (
    <Modal
      open={isOpen}
      variant="default"
      onClose={handleClose}
      title={translateString('Save As Document Repository')}
      buttonProps={[
        {
          label: translateString('Cancel'),
        },
        {
          label: translateString('Save'),
          onClick: handleSaveProgressButton,
          disabled: error.hasError,
        },
      ]}
      className={classes.modal}
      disableBackdropClick
    >
      <TextField
        label={translateString('Document Repository Name')}
        placeholder={translateString('Document Repository Name...')}
        name="repositoryName"
        value={repositoryName}
        onChange={(e) => setRepositoryName(e.target.value)}
        onBlur={handleSavedSearchNameFieldBlur}
        error={error.hasError}
        helperText={error.hasError ? translateString(error.errorText) : null}
        InputProps={{
          inputProps: {
            maxLength: 120,
          },
        }}
        fullWidth
        required
      />
    </Modal>
  );
};

export default SaveAsModal;
